import 'angular';
import { capitalCase } from 'change-case';

angular.module('filters.reportTypeDisplay', [])
  .filter('reportTypeDisplay', function () {
    return function(type) {
      if (['tender', 'grant'].indexOf(type) >= 0) {
        return capitalCase(type);
      }
    };
  });
